import React from "react";
import "./Devices.css";
import ConnectedDevices from "./ConnectedDevices.js";
import useState from "react";

const AvailableDevices = ({
  devices_list,
  device_connector_mapping,
  selectedConnector,
  connectorsList,
  updateConnectorsListWithDevices,
  adapters_list,
}) => {
  const getDevicesForConnector = (connector) => {
    const connector_mapping = device_connector_mapping.find(
      (mapping) => mapping.connector_id === connector.id
    );
    return connector_mapping.devices.map((device) =>
      devices_list.find(
        (item_device_find) => item_device_find.id === device.device_id
      )
    );
  };

  const getConnectedDevicesForConnector = (connector) => {
    const devices_id = connectorsList.filter(
      (connector_item) => connector_item.id === connector.id
    )[0].connected_devices_id;
    return devices_id.map((device_id) =>
      devices_list.find((device) => device.id === device_id)
    );
  };

  const getDeviceConnectionDetail = (device, connector) => {
    const found_device_connector_mapping = device_connector_mapping.find(
      (item) => item.connector_id === connector.id
    );
    const device_connection_detail =
      found_device_connector_mapping.devices.find(
        (item) => item.device_id === device.id
      );
    return device_connection_detail;
  };

  return (
    <>
      {/* <h3>Devices</h3> */}
      {selectedConnector ? (
        <div className="device-connector-list-section px-2">
          <span className="fs-5">Devices compatible with this connector:</span>
          <div className="device-connector-list row row-cols-3 row-cols-sm-4 row-cols-md-3 row-cols-lg-4 row-cols-xl-6 g-2 mb-2">
            {getDevicesForConnector(selectedConnector).map((device) => (
              <div className="col">
                <div className="card h-100" key={device.id}>
                  <img
                    src={`${process.env.PUBLIC_URL}/images/devices/${device.img_name}`}
                  />
                  <div className="card-body p-1">
                    <div>{device.name}</div>
                  </div>
                  <div className="card-footer p-0">
                    {getConnectedDevicesForConnector(selectedConnector).length >
                    0 ? (
                      getConnectedDevicesForConnector(selectedConnector)[0]
                        .id === device.id ? (
                        <button
                          className="btn btn-danger w-100 px-1"
                          onClick={() =>
                            updateConnectorsListWithDevices(
                              [],
                              selectedConnector
                            )
                          }
                        >
                          Disconnect
                        </button>
                      ) : (
                        <button
                          className="btn btn-primary w-100 px-1"
                          onClick={() =>
                            updateConnectorsListWithDevices(
                              [device.id],
                              selectedConnector
                            )
                          }
                        >
                          Connect
                        </button>
                      )
                    ) : (
                      <button
                        className="btn btn-primary w-100 px-1"
                        onClick={() =>
                          updateConnectorsListWithDevices(
                            [device.id],
                            selectedConnector
                          )
                        }
                      >
                        Connect
                      </button>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      ) : (
        <div className="no-connector-selected text-center  text-warning fs-3"></div>
      )}
    </>
  );
};

export default AvailableDevices;
